import { FC, useMemo } from 'react';
import { PolicyMeta } from '@/lib/models/policy-model-v1';
import UsageCard from '../usage-card';
import { ScrollAnchorId } from '../scroll-anchor/helpers';
import { UsageItem } from '../usage-card/helpers';
import PolicyLink from '../policy-link';

interface Props {
  policies: PolicyMeta[];
  policyLinkTab?: string;
  policyLinkScrollId?: ScrollAnchorId;
}

const PolicyUsageCard: FC<Props> = ({ policies, policyLinkTab, policyLinkScrollId }) => {
  const items = useMemo(() => {
    return policies.map((policy) => {
      const { id } = policy;

      const usageItem: UsageItem = {
        id,
        EntityLinkEl: (
          <PolicyLink
            policy={policy}
            policyLinkTab={policyLinkTab}
            policyLinkScrollId={policyLinkScrollId}
          />
        ),
      };

      return usageItem;
    });
  }, [policies, policyLinkScrollId, policyLinkTab]);

  return <UsageCard title="Policies" items={items} icon="policy" />;
};

export default PolicyUsageCard;
